import { translate } from '@openclassrooms/translations';
import { CourseType, ChapterType } from '../_types';
import tocItemToUrl from '../../_utils/tocItemToUrl';

interface FooterInformation {
  label: string;
  url: string;
}

const TOC_TYPES = {
  MCQ: 'MCQ',
  SUBTITLE: 'subtitle',
};

const getFooterInformation = (
  course: CourseType,
  nextChapter: ChapterType | null,
  searchParams?: string
): FooterInformation => {
  const url = tocItemToUrl(course, nextChapter, searchParams);

  if (!nextChapter) {
    return {
      label: translate('next_cta.end'),
      url,
    };
  }

  const label =
    nextChapter.type === TOC_TYPES.MCQ
      ? translate('next_cta.quiz')
      : translate('course.chapter.cta.next');

  return {
    label,
    url,
  };
};

export default getFooterInformation;
